import { string } from 'prop-types';
import { IKeyValue, IKeyValueNumber } from 'shared/utils';
import { ITags } from './campanhas';
import { IComunicacao } from './campanhas';

export interface IListagemCrib {
  IdCampanha: number,
  flag: string,
  grupoControle: number,
  calcGrupo: number,
  queryBusiness: string,
  valorInteiro: number,
  inicioRange: number,
  fimRange: number,
  porcentagem:number,
  statusCamp: string,  
  grupo_controle:number,
  Calculo_Grupo:number,
}





export interface IListagemCribLog {
  IdExec: string,
  Id:number,
  IdCampanha: number,
  Step: number,
  StepJson: string,
  StepDesc: string,
  StepStatus: string  ,
  StepDth: Date
}

export interface IRespListagemCrib {
  cribLogList:IListagemCribLog[];
}

export interface IResponseCrib {


  output: string;


}


export const listKeyValueFlag: IKeyValue[] = [
  {
    key: '',
    value: ''
  },
  {
    key: 'on',
    value: 'Ligado'
  }, {
    key: 'off',
    value: 'Desligado'
  }
];


export const listKeyValueCribFormat: IKeyValue[] = [
  {
    key: '',
    value: ''
  },
  {
    key: 'Original',
    value: 'Original'
  }, {
    key: 'Teste',
    value: 'Teste'
  }];

export const listKeyValueGrupoControle: IKeyValueNumber[] = [
  {
    key: 1,
    value: ''
  },
  {
    key: 2,
    value: 'Por Canal'
  }, {
    key: 40,
    value: 'Geral'
  }];

export const listKeyValueCalculoGC: IKeyValueNumber[] = [


  {
    key: 0,
    value: ''
  },
  {
    key: 1,
    value: 'Porcentagem'
  },
  {
    key: 2,
    value: 'Inteiro'
  },
  {
    key: 3,
    value: 'Função'
  },
  {
    key: 4,
    value: 'Range CPF'
  }
];


export interface IUpdateCrib {
  idCampanha?: number,
  status?: string,
  grupoControle?: number ,
  calcGrupo?: number,
  queryBusiness?: string,
  grupo_controle?:number,
  Calculo_Grupo?:number,
  valorInteiro?: number,
  inicioRange?: number,
  fimRange?: number,
  porcentagem?:number,
  idCanal?: IComunicacao[],
  tags?: ITags[],
  TipoCampanha?:string,

 
}



export const InicitalUpdateCrib = {
  Id: 0,
  Query: '',
  removidos: 0,
  validos: 0,
  email: 0,
  push: 0,
  sms: 0



};


export interface ICampanhas {
  IdCampanha: string;

}





export const listaNumerosCampanhas: IKeyValue[] = [
  {
    key: '1234',
    value: '1234'
  },
  {
    key: '5678',
    value: '5678'
  },
  {
    key: '9012',
    value: '9012'
  },
  {
    key: '3456',
    value: '3456'
  },
  {
    key: '9876',
    value: '9876'
  },
  {
    key: '5432',
    value: '5432'
  },
  {
    key: '1098',
    value: '1098'
  },
  {
    key: '7654',
    value: '7654'
  },
  {
    key: '2468',
    value: '2468'
  },
  {
    key: '1357',
    value: '1357'
  },
];